"use strict";

import React, {useContext, useEffect, useState} from 'react';
import AccountEchecksCreateFinancialAccountForm from "./AccountEchecksCreateFinancialAccountForm";
import formatPhoneNumber from "../../formatPhoneNumber";
import axios from "../utilities/axiosEcheckWrapper";
import {useAlert} from "react-alert";

const AccountEchecksCreateFinancialAccount = ({
      isFetchingAccount=false,
      financialAccountData={},
      email='',
      userAddress={},
      onSubmit=()=>{},
  }) => {
    const [data, setData] = useState({});

    useEffect(()=>{
        setData(()=>{
            if(!!financialAccountData && Object.keys(financialAccountData).length > 0){
                return {...financialAccountData};
            }
            else{
               return {
                   email: email,
                   company_name: userAddress.company_name,
                   f_name: userAddress.f_name,
                   l_name: userAddress.l_name,
                   phone: formatPhoneNumber(userAddress.phone || '' ),
                   address: userAddress.address,
                   city: userAddress.city,
                   state: userAddress.state,
                   zip: userAddress.zip5,
               };
            }
        });

        },
        [financialAccountData, email, userAddress, setData]
    );

    return (
        <React.Fragment>
            {isFetchingAccount &&
                <div style={{position: 'relative',}}>
                    Getting account information...
                    <div className="loading loading--cover loading--center-flex loading--w-flip" />
                </div>
                ||
                <AccountEchecksCreateFinancialAccountForm
                    data={data}
                    onSubmit={onSubmit} />
            }
        </React.Fragment>
    );
}

export default AccountEchecksCreateFinancialAccount;
